// DS2.3
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink from '../PlainButtonOrLink';
import useIconSizeForButtonSize from '../hooks/useIconSizeForButtonSize';
import s from './TextButton.scss';
/**
 * If {@link componentOrNode} is a {@link React.ComponentType}, we'll render it via the supplied
 * {@link renderComponent}. Otherwise, we'll return it outright.
 *
 * Utility for props that accept a {@link React.ComponentType} or a {@link React.ReactNode}.
 *
 * ---
 * ```
 *  postfix: React.ComponentType<IconProps> | React.ReactNode;
 *
 *  // Then, in your component
 *  <>
 *    {renderComponentTypeOrNode(postfix, (PostfixIconComponent) =>
 *      // This is only called if `postfix` is a React.ComponentType
 *      <PostfixIconComponent {...yourProps} />
 *    )}
 *  </>
 * ```
 */ function renderComponentTypeOrNode(componentOrNode, renderComponent, renderNode) {
    if (typeof componentOrNode === 'function') {
        return renderComponent(componentOrNode);
    }
    return renderNode ? renderNode(componentOrNode) : componentOrNode;
}
const TextButton = (_param)=>{
    var { size, noHorizontalPaddings = true, variant, priority = 'primary', className, children, icon: IconComponent, iconProps, postfix, iconClassName, loading } = _param, props = _object_without_properties(_param, [
        "size",
        "noHorizontalPaddings",
        "variant",
        "priority",
        "className",
        "children",
        "icon",
        "iconProps",
        "postfix",
        "iconClassName",
        "loading"
    ]);
    const iconSize = useIconSizeForButtonSize(size);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, _object_spread({
        className: classnames(className, s['root'], s[`variant-${variant}`], s[`priority-${priority}`], s[`size-${size}`], noHorizontalPaddings && s['no-horizontal-paddings'], props.disabled && s['disabled'], loading && s['loading'])
    }, props), IconComponent && /*#__PURE__*/ React.createElement(IconComponent, _object_spread({
        className: classnames(s['prefix'], iconClassName),
        size: iconSize,
        disableDefaultColors: true
    }, iconProps)), /*#__PURE__*/ React.createElement("span", {
        className: s['content']
    }, children), postfix && renderComponentTypeOrNode(postfix, (PostfixIconComponent)=>/*#__PURE__*/ React.createElement(PostfixIconComponent, {
            className: s['postfix'],
            size: iconSize,
            disableDefaultColors: true
        }), (node)=>/*#__PURE__*/ React.createElement("span", {
            className: s['postfix']
        }, node)));
};
TextButton.displayName = 'TextButton';
export default TextButton;

//# sourceMappingURL=TextButton.js.map